// ==========================================================================
// Legal content (DE / Schweiz) — Impressum, Datenschutz, AGB
// Platzhalter sind mit [ eckigen Klammern ] markiert -> bitte ausfüllen.
// Hinweis: Vorlagentexte, keine Rechtsberatung.
// ==========================================================================

export const COMPANY = {
  name: "InteliSoft AG",
  street: "Münchensteinerstrasse 128",
  zip: "4052",
  city: "Basel",
  country: "Schweiz",
  email: "info@intelisoft.ai",
  phone: "+41 61 000 00 00",
  uid: "CHE-232.092.184",
  vat: "[CHE-000.000.000 MWST]",
  register: "[Handelsregister des Kantons Basel-Stadt]",
  board: "[Name(n) des Verwaltungsrats]",
  responsible: "[Name der verantwortlichen Person]",
};

const c = COMPANY;
const lastUpdate = "Juli 2025";

export const IMPRESSUM = {
  title: "Impressum",
  updated: lastUpdate,
  sections: [
    {
      heading: "Angaben gemäss Gesetz",
      paragraphs: [
        `${c.name}`,
        `${c.street}`,
        `${c.zip} ${c.city}, ${c.country}`,
      ],
    },
    {
      heading: "Kontakt",
      paragraphs: [`Telefon: ${c.phone}`, `E-Mail: ${c.email}`, `Website: www.intelisoft.ai`],
    },
    {
      heading: "Handelsregister / Unternehmens-Identifikation",
      paragraphs: [
        `Unternehmens-Identifikationsnummer (UID): ${c.uid}`,
        `Mehrwertsteuernummer: ${c.vat}`,
        `Eingetragen im ${c.register}`,
      ],
    },
    {
      heading: "Vertretungsberechtigte Personen",
      paragraphs: [`${c.board}`, `Verantwortlich für den Inhalt: ${c.responsible}`],
    },
    {
      heading: "Haftungsausschluss",
      paragraphs: [
        "Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen. Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen entstanden sind, werden ausgeschlossen.",
        "Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.",
      ],
    },
    {
      heading: "Haftung für Links",
      paragraphs: [
        "Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des jeweiligen Nutzers.",
      ],
    },
    {
      heading: "Urheberrechte",
      paragraphs: [
        `Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website gehören ausschliesslich ${c.name} oder den speziell genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.`,
      ],
    },
  ],
};

export const DATENSCHUTZ = {
  title: "Datenschutzerklärung",
  updated: lastUpdate,
  sections: [
    {
      heading: "1. Verantwortliche Stelle",
      paragraphs: [
        "Verantwortlich für die Datenbearbeitung auf dieser Website ist:",
        `${c.name}, ${c.street}, ${c.zip} ${c.city}, ${c.country}`,
        `E-Mail: ${c.email} · Telefon: ${c.phone}`,
      ],
    },
    {
      heading: "2. Grundsätze",
      paragraphs: [
        "Wir bearbeiten Personendaten im Einklang mit dem Schweizer Bundesgesetz über den Datenschutz (revDSG) sowie – soweit anwendbar – der Datenschutz-Grundverordnung der EU (DSGVO). Personendaten werden vertraulich behandelt und nur für die angegebenen Zwecke verwendet.",
      ],
    },
    {
      heading: "3. Bearbeitung beim Besuch der Website (Server-Logs)",
      paragraphs: [
        "Beim Aufrufen unserer Website werden durch den Hosting-Provider automatisch Informationen in Server-Logfiles gespeichert, die Ihr Browser übermittelt (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite, verwendeter Browser und Betriebssystem). Diese Daten dienen der technischen Sicherheit und dem stabilen Betrieb der Website.",
      ],
    },
    {
      heading: "4. Cookies & Reichweitenmessung",
      paragraphs: [
        "Wir setzen Cookies und ein Analyse-Tool (PostHog) ein, um die Nutzung unserer Website zu verstehen und diese zu verbessern. Dabei können auch anonymisierte Sitzungsaufzeichnungen erstellt werden. Diese Bearbeitung erfolgt ausschliesslich nach Ihrer Einwilligung über unser Cookie-Banner.",
        "Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie die Cookie-Einstellungen erneut aufrufen oder Cookies in Ihrem Browser löschen.",
      ],
    },
    {
      heading: "5. Kontaktformular",
      paragraphs: [
        "Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben (Name, E-Mail-Adresse, Telefonnummer, Nachricht) zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert und per E-Mail an uns übermittelt. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.",
      ],
    },
    {
      heading: "6. Newsletter",
      paragraphs: [
        "Bei der Anmeldung zum Newsletter speichern wir Ihre E-Mail-Adresse, um Ihnen Informationen zusenden zu können. Sie können den Newsletter jederzeit abbestellen; die Einwilligung zur Speicherung wird damit widerrufen.",
      ],
    },
    {
      heading: "7. Weitergabe an Dritte / Hosting",
      paragraphs: [
        "Zur Bereitstellung unserer Website und Dienste arbeiten wir mit sorgfältig ausgewählten Dienstleistern (z. B. Hosting- und E-Mail-Anbieter) zusammen, die Daten in unserem Auftrag bearbeiten. Eine Weitergabe zu anderen Zwecken erfolgt nur, wenn wir gesetzlich dazu verpflichtet sind oder Sie eingewilligt haben.",
      ],
    },
    {
      heading: "8. Ihre Rechte",
      paragraphs: [
        "Sie haben im Rahmen der geltenden Gesetze das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Bearbeitung Ihrer Personendaten sowie das Recht, eine erteilte Einwilligung zu widerrufen. Zur Ausübung Ihrer Rechte genügt eine Mitteilung an die oben genannte Kontaktadresse.",
      ],
    },
    {
      heading: "9. Datensicherheit",
      paragraphs: [
        "Wir treffen angemessene technische und organisatorische Sicherheitsmassnahmen, um Ihre Daten gegen unbefugten Zugriff, Verlust oder Missbrauch zu schützen. Die Übertragung erfolgt verschlüsselt (SSL/TLS).",
      ],
    },
    {
      heading: "10. Änderungen",
      paragraphs: [
        "Wir behalten uns vor, diese Datenschutzerklärung jederzeit anzupassen. Es gilt die jeweils aktuelle, auf dieser Website veröffentlichte Fassung.",
      ],
    },
  ],
};

export const AGB = {
  title: "Allgemeine Geschäftsbedingungen (AGB)",
  updated: lastUpdate,
  sections: [
    {
      heading: "1. Geltungsbereich",
      paragraphs: [
        `Diese AGB gelten für alle Verträge und Leistungen zwischen der ${c.name} (nachfolgend „Anbieter") und ihren Kundinnen und Kunden (nachfolgend „Kunde"). Abweichende Bedingungen des Kunden gelten nur, soweit der Anbieter ihnen ausdrücklich schriftlich zugestimmt hat.`,
      ],
    },
    {
      heading: "2. Vertragsgegenstand",
      paragraphs: [
        "Der Anbieter entwickelt und betreibt individuelle Software- und SaaS-Lösungen. Der konkrete Leistungsumfang ergibt sich aus dem jeweiligen Angebot bzw. der Auftragsbestätigung.",
      ],
    },
    {
      heading: "3. Angebot und Vertragsschluss",
      paragraphs: [
        "Angebote des Anbieters sind freibleibend. Ein Vertrag kommt durch schriftliche Auftragsbestätigung oder Beginn der Leistungserbringung zustande.",
      ],
    },
    {
      heading: "4. Mitwirkung des Kunden",
      paragraphs: [
        "Der Kunde stellt alle für die Leistungserbringung erforderlichen Informationen, Inhalte und Zugänge rechtzeitig und vollständig bereit. Verzögerungen aufgrund fehlender Mitwirkung gehen nicht zulasten des Anbieters.",
      ],
    },
    {
      heading: "5. Preise und Zahlung",
      paragraphs: [
        "Es gelten die im Angebot genannten Preise, zzgl. gesetzlicher Mehrwertsteuer. Rechnungen sind innert 30 Tagen ab Rechnungsdatum ohne Abzug zahlbar, sofern nichts anderes vereinbart ist.",
      ],
    },
    {
      heading: "6. Nutzungsrechte",
      paragraphs: [
        "Mit vollständiger Bezahlung erhält der Kunde die vereinbarten Nutzungsrechte an der erstellten Software. Eingesetzte Standard-Komponenten, Bibliotheken und Frameworks unterliegen ihren jeweiligen Lizenzbedingungen.",
      ],
    },
    {
      heading: "7. Gewährleistung",
      paragraphs: [
        "Der Anbieter gewährleistet eine fachgerechte Erbringung der Leistungen. Mängel sind unverzüglich schriftlich anzuzeigen; der Anbieter ist berechtigt, Mängel nachzubessern.",
      ],
    },
    {
      heading: "8. Haftung",
      paragraphs: [
        "Der Anbieter haftet nur für Schäden, die auf vorsätzlichem oder grobfahrlässigem Verhalten beruhen. Die Haftung für leichte Fahrlässigkeit sowie für indirekte Schäden und Folgeschäden ist im gesetzlich zulässigen Rahmen ausgeschlossen.",
      ],
    },
    {
      heading: "9. Vertraulichkeit",
      paragraphs: [
        "Beide Parteien verpflichten sich, alle im Rahmen der Zusammenarbeit erlangten vertraulichen Informationen geheim zu halten und nur für die Vertragserfüllung zu verwenden.",
      ],
    },
    {
      heading: "10. Laufzeit und Kündigung",
      paragraphs: [
        "Laufzeit und Kündigungsfristen richten sich nach der jeweiligen Vereinbarung. Das Recht zur ausserordentlichen Kündigung aus wichtigem Grund bleibt vorbehalten.",
      ],
    },
    {
      heading: "11. Anwendbares Recht und Gerichtsstand",
      paragraphs: [
        `Es gilt ausschliesslich Schweizer Recht unter Ausschluss des UN-Kaufrechts (CISG). Ausschliesslicher Gerichtsstand ist ${c.city}, Schweiz, soweit gesetzlich zulässig.`,
      ],
    },
    {
      heading: "12. Salvatorische Klausel",
      paragraphs: [
        "Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
      ],
    },
  ],
};

export const LEGAL_DOCS = {
  impressum: IMPRESSUM,
  datenschutz: DATENSCHUTZ,
  agb: AGB,
};
